import { UseRestMutationOptions, useRestMutation } from 'utils/hooks/api';
import { ApiMethod } from 'services/api';

export const LABELS_URL = '/i/labels';

export type CreateLabelResponse = {
  message: string;
  newLabel: {
    id: number;
    name: string;
    projectId: number;
  };
};

export type LabelBody = {
  name: string;
};

export const useCreateLabel = (options?: UseRestMutationOptions<CreateLabelResponse>) =>
  useRestMutation<CreateLabelResponse, LabelBody>(LABELS_URL, ApiMethod.post, options);

export const useEditLabel = (id: number, options?: UseRestMutationOptions<string>) => {
  const url = `${LABELS_URL}/${id}`;
  return useRestMutation<string, LabelBody>(url, ApiMethod.post, options);
};

export const useDeleteLabel = (id: number, options?: UseRestMutationOptions<string>) => {
  const url = `${LABELS_URL}/${id}`;
  return useRestMutation<string>(url, ApiMethod.delete, options);
};
